import { ALLOWED_COMPANY_STATUS_LOGIN, DEFAULT_SIGN_UP_ATTRIBUTES } from './constants';

/**
 * @param {object} company - company data from enrolledCompanies query
 * @returns {object} - formatted company data
 */
export const formatCompanyData = company => ({
  ksuid: company?.ksuid,
  name: company?.company?.aliasName || company?.name,
  status: company?.status,
  accessType: company?.accessType,
  // isNftFreeTrialExpired used specifically for NFT Free Trial checker
  isNftFreeTrialExpired: company?.company?.isNftFreeTrialExpired,
  metadata: company?.company?.metadata,
  hasConsentedCustomer: !!company?.company?.hasConsentedCustomer,
  isPremiumAccess: company?.company?.nfsMainCompanyConfig?.isPremiumAccess
});

/**
 * @param {object} props - company data
 * @param {string} props.status - company status
 * @returns {boolean} - whether company allowed to login or not
 */
export const isAllowedToLogin = (
  /* istanbul ignore next */
  { status } = {}
) => ALLOWED_COMPANY_STATUS_LOGIN.includes(status);

/**
 * Object formatter for aws cognito sign up
 *
 * @param {object} props - registration data
 * @param {string} props.companyName - company name
 * @param {string} props.email - user email which later will be used as company email
 * @param {string} props.name - user full name
 * @param {string} props.password - user password
 * @param {string} props.phoneNumber - user phone number
 * @returns {object} - formatted aws cognito registration data
 */
export const formatSignUpAuthData = ({
  companyName,
  email,
  name,
  password,
  phoneNumber,
}) => ({
  username: phoneNumber,
  password,
  attributes: {
    ...DEFAULT_SIGN_UP_ATTRIBUTES,
    phone_number: phoneNumber,
    name,
    email,
    'custom:company_name': companyName,
  },
});

/**
 * Clear all storage (localStorage) items and keep specific items if needed
 *
 * @param {localStorage} persistentDataStorage - storage that needs to be cleared (localStorage)
 * @param {Array} preservedLocalStorageKeys - local storage item keys to be preserved after clearing
 */
export const clearStorageItems = (
  persistentDataStorage,
  /* istanbul ignore next */
  preservedLocalStorageKeys = [],
) => {
  try {
    const preservedStorageItems = preservedLocalStorageKeys.map(key => ({
      key,
      value: persistentDataStorage.getItem(key)
    }));
    persistentDataStorage.clear();
    preservedStorageItems.forEach(({ key, value }) => {
      persistentDataStorage.setItem(key, value);
    });
  } catch {
    // do nothing
  }
};

export default {};
